import { getStoreNumberComparator } from '@utils/grid'

export function getColumnDefs(formatCurrency, costDiffStyle, deltaCellRenderer) {
  return [
    {
      headerName: 'Market',
      field: 'market',
      filter: true,
    },
    {
      headerName: 'Sector',
      field: 'sector',
      rowGroup: true,
      filter: true,
      hide: true,
    },
    {
      headerName: 'Site Number',
      field: 'site_number',
      filter: true,
      comparator: getStoreNumberComparator('site_number'),
    },
    {
      headerName: 'Site Name',
      field: 'site_name',
      filter: true,
      comparator: getStoreNumberComparator('site_name'),
      hide: true,
    },
    {
      headerName: 'Tank ID',
      field: 'tank_id',
      filter: true,
    },
    {
      headerName: 'Product',
      field: 'product',
      rowGroup: true,
      filter: true,
      hide: true,
    },
    {
      headerName: 'Product Group',
      field: 'product_group',
      filter: true,
    },
    {
      headerName: 'Price',
      field: 'price',
      aggFunc: 'avg',
      headerTooltip: 'Product Price + Freight Price',
      filter: 'agNumberColumnFilter',
      valueFormatter: (params) => formatCurrency(Number(params?.value), true, 4),
      cellStyle: () => ({ textAlign: 'right' }),
    },
    {
      headerName: 'Product Price',
      field: 'product_price',
      hide: true,
      aggFunc: 'avg',
      filter: 'agNumberColumnFilter',
      valueFormatter: (params) => formatCurrency(Number(params?.value), true, 4),
      cellStyle: () => ({ textAlign: 'right' }),
    },
    {
      headerName: 'Freight Price',
      field: 'freight_price',
      hide: true,
      aggFunc: 'avg',
      filter: 'agNumberColumnFilter',
      valueFormatter: (params) => formatCurrency(Number(params?.value), true, 4),
      cellStyle: () => ({ textAlign: 'right' }),
    },
    {
      headerName: 'Price Type',
      field: 'price_type',
      filter: true,
    },
    {
      headerName: 'Supplier',
      field: 'supplier',
      filter: true,
    },
    {
      headerName: 'Terminal',
      field: 'terminal',
      filter: true,
    },
    {
      headerName: 'Delta To Previous',
      field: 'delta_to_previous',
      aggFunc: 'avg',
      filter: 'agNumberColumnFilter',
      cellStyle: costDiffStyle,
      cellRenderer: deltaCellRenderer,
      cellRendererParams: { align: 'right' },
    },
  ]
}
